import { z } from 'zod';
export const loginInput = z.object({
    // Primero se recorta y se pasa a minúsculas, y recién después se valida (un espacio final del teclado móvil no debe rechazar el correo).
    email: z.string().trim().toLowerCase().pipe(z.email('Correo inválido')),
    password: z.string().min(1, 'Ingresá tu contraseña').max(256),
});
export const passwordPolicy = z
    .string()
    .min(10, 'Mínimo 10 caracteres')
    .max(128)
    .regex(/[a-zA-Z]/, 'Debe incluir letras')
    .regex(/\d/, 'Debe incluir números');
export const updateProfileInput = z.object({
    name: z.string().trim().min(2, 'Requerido').max(120),
});
export const changePasswordInput = z
    .object({
    currentPassword: z.string().min(1, 'Requerido').max(256),
    newPassword: passwordPolicy,
})
    .refine((v) => v.currentPassword !== v.newPassword, {
    path: ['newPassword'],
    message: 'La nueva contraseña debe ser distinta',
});
export const forgotPasswordInput = z.object({
    // Primero se recorta y se pasa a minúsculas, y recién después se valida (un espacio final del teclado móvil no debe rechazar el correo).
    email: z.string().trim().toLowerCase().pipe(z.email('Correo inválido')),
});
export const resetPasswordInput = z.object({
    token: z.string().min(20).max(200),
    password: passwordPolicy,
});
//# sourceMappingURL=auth.js.map